<template>
    <div class="mb-4" v-if="detailData">
        <div class="d-flex align-items-center mb-2 label_box">
            <label class="mb-0">{{label}}</label>
            <router-link :to="localePath('/how-to-find-ring-size')" v-if="['size', 'her_size', 'his_size'].includes(type)">
                <SvgHeaderSvg class="ml-2" :type="'ask'" />
            </router-link>
           
        </div>
        <div v-if="dropdownOptions" tabindex="0" @focusout="showOptions = false" class="drop_block" :class="{ 'invalid': mode }">
            <div class="current_active" @click="showOptions = !showOptions">
                <div class="d-flex align-items-center">
                    <!-- <SvgMetalSvg v-if="currentActive && currentActive.icon != null" :type="currentActive.icon" /> -->
                     <div v-if="currentActive && currentActive.icon != null" :type="currentActive.icon" >
                        <img v-if="currentActive.icon ==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                        <img v-if="currentActive.icon ==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                        <img v-if="currentActive.icon ==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                    </div>
                   
                    <span>{{currentActive.label}}</span>
                </div>
                <SvgHeaderSvg v-if="!showOptions" :type="'down'" />
                <SvgHeaderSvg v-else :type="'up'" />
            </div>
            
            <ul class="p-0" v-show="showOptions">
                <li v-for="(list, key) in dropdownOptions"
                    :key="key"
                    @click="toggleOption(list)"
                    :class="{'active': list.selected === 1}"
                >
                    <!-- <SvgMetalSvg v-if="list.icon != null" :type="list.icon" /> -->
                     <div v-if="list.icon != null" :type="list.icon">
                         <img v-if="list.icon ==='white'" width="50" height="50" src="~/assets/metals/white.png"/>
                         <img v-if="list.icon ==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png"/>
                         <img v-if="list.icon ==='rose'" width="50" height="50" src="~/assets/metals/rose.png"/>
                     </div>

                    <span>{{list.label}} </span>
                    <span v-if="list.default && list.default === 1">&nbsp;(default)</span>
                </li>
            </ul>
        </div>
        <div v-else class="skeleton">
            <!-- <b-skeleton height="44px" width="100%"></b-skeleton> -->
        </div>
        
        <div class="error_boxx" v-if="mode">{{ mode.join(" ") }}</div>

        <p class="mb-0 pt-1" v-if="detailData.sub_type === 'full-eternity-ring' && type === 'size'" >* Eternity rings cannot be resized. <router-link :to="localePath('/customer-service/ring-resizing')">Read more</router-link></p>

    </div>
 
</template>

<script setup>

    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()

    const localePath = useLocalePath();
    const route = useRoute()
    const router = useRouter()

    const { type, label, mode } = defineProps(['type', 'label', 'mode'])

    const showOptions = ref(false)

    const detailData = computed(() =>{
        return store.getDetailData
    })

    const dropdownOptions = computed(() =>{
        return store.getMetalDropDownList('')
    })

    const currentActive = computed(() =>{
        return dropdownOptions.value.find(item => item.selected === 1)
    })

    // const currentCarat = computed(() =>{
    //     return store.getCurrentActive('carat')
    // })

    // const currentMetal = computed(() =>{
    //     return store.getCurrentActive('metal')
    // })


    const isFastShip = computed(() =>{
        if(route.query.FastShip == 'true'){
            return true
        }
        return false
    })

    watch( 
        () => route.params.slug,
        (nv) => {
              
            // Ensure options are available and non-empty
            const availableOptions = store.getDropDownList('metal') || [];
          
            let urlMetal = availableOptions.find(metal => 
            metal?.carats?.some(carat => carat?.slug === nv)
            );
            
            let urlCarat = urlMetal.carats.find( cv => cv.slug === nv )
            
            const getCurrentActiveMetal = store.getCurrentActive('metal')

            if( urlMetal.value !== getCurrentActiveMetal.value ){

                store.setActive({ value: urlMetal.value, type : 'metal' });
            }

            const getCurrentActiveCarat = store.getCurrentActive('carat')

            if( urlCarat.value != getCurrentActiveCarat.value ){

                store.setActive({ value: urlCarat.value, type : 'carat' });
            }

            const mt = store.getCurrentActive('metal')
            const ct = store.getCurrentActive('carat')

            store.setActive({ value: `${mt.value}_${ct.value}`, type : 'metalCaratDropdown' });
        }
    )

    async function toggleOption(option){
        const availableOptions = store.getDropDownList('metal') || []

        let activeMetal = availableOptions.find(metal => metal.value === option.metal);

        if(!activeMetal || !activeMetal?.carats ) return

        let carat = activeMetal.carats.find( carat => carat?.value === option.weight_value )

        router.push( { name: route.name, params:{ slug : carat.slug }, query: route.query },  )

        showOptions.value = false      
    }
</script>

<style scoped>
  .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
.current_active .svg-head {
    height: 12px;
    width: 20px;
}
p{
    font-size: 12px;
    font-weight: 600;
}
p a{
    color: var(--green);
}

.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}
.label_box {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}
.label_box div{
    color: rgb(159, 158, 158);
    cursor: pointer;
}
.drop_block{
    position: relative;
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 8px;
}


.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}
ul {
    border: 1px solid #c4c4c4;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 220px;
    overflow: auto;
    border-radius: 8px;
}
ul li{
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}
ul li.active {
    background: rgba(204,204,204,0.36863);
}
span{
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    text-transform: capitalize;
    margin-left: 10px;
}
label{
    color: #303030;
    font-size: 16px;
    font-weight: 600;
}

</style>
